<div class="debug-output no-print" *ngIf="show" [class.open]="open">
  <i class="icon-robot" (click)="toggleOpen()" title="Debug Informationen"></i>
  <div class="content" *ngIf="open">
    <table>
      <thead>
      <tr>
        <th>Wert</th>
        <th>Daten</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let item of this.data | keyvalue">
        <td>{{item.value.name}}</td>
        <td>
          <pre *ngIf="isUrl(item.value.data) === false">{{item.value.data | json}}</pre>
          <a *ngIf="isUrl(item.value.data) === true" [href]="item.value.data" target="_blank">Link</a>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</div>
